import { Component, Input } from "@angular/core";
import { Chart } from "chart.js";
import { ChartJsData, ChartJsDataset } from "../../../models/ChartJsDataset";
import { GetESGChartResponse, GetESGMatrixResponse } from "../../../WebApiClient";

@Component({
    selector: "app-sustainability-esg-chart",
    templateUrl: "./sustainability-chart.component.html",
    styleUrls: [
        "./sustainability-chart.component.scss"
    ],
    standalone: false
})
export class SustainabilityChartComponent {
    public chart: any;
    data: ChartJsData | undefined = undefined;

    @Input()
    esgChartData: GetESGChartResponse | undefined;

    constructor() {

    }

    ngOnInit(): void {
        if (this.esgChartData) {
            this.createChart();
        }
    }

    createChart() {
        if (!this.esgChartData) {
            return;
        }

        let datasets : ChartJsDataset[] = this.esgChartData.datasets!
        .map((x) => {
            return  {
                label: x.label!,
                data: x.data!,
                backgroundColor: x.backgroundColor!,
            } as ChartJsDataset;
        });

        this.data = {
            labels: ["SCOPE 1", "SCOPE 2", "SCOPE 3", "OUT OF SCOPE"],
            datasets: datasets,
        };

        if (this.chart) {
            this.chart.destroy();
        }

        this.chart = new Chart("BarChart", {
            type: "bar",
            data: this.data,
            options: {
                animation: false,
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: false,
                    },
                    y: {
                        stacked: false,
                    },
                },
            },
        });
    }
}
